import { getIsCentralMode } from '../../../commons/utils/localStorage';

// Use location here because we don't have direct access to props here, and this function can we used everywhere
export const getIsInCentralKitchenOnlyPage = () =>
  getIsCentralMode() && window.location.pathname.startsWith('/admin/kitchen-products');
